import { render, staticRenderFns } from "./avatar-field.vue?vue&type=template&id=0760a510&scoped=true"
import script from "./avatar-field.vue?vue&type=script&lang=js"
export * from "./avatar-field.vue?vue&type=script&lang=js"
import style0 from "./avatar-field.vue?vue&type=style&index=0&id=0760a510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760a510",
  null
  
)

export default component.exports